import { FX_PRESETS } from "./mediaFx";
import { clampBeauty } from "./liveBeauty";

// Lot 644 — « look » du direct (preset couleur + lissage) mémorisé sur l'appareil ; une mémoire par église
// quand on diffuse en son nom (clé suffixée), sinon la mémoire personnelle.
const FX_KEY = "yalola.live.fx";
const BEAUTY_KEY = "yalola.live.beauty";

const scoped = (base, churchId) => (churchId ? `${base}.church.${churchId}` : base);
const get = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const set = (k, v) => { try { localStorage.setItem(k, v); } catch { /* noop */ } };
const validFx = (v) => FX_PRESETS.some((p) => p.key === v);

// Personnel : toujours une valeur (normal / 0). Église : undefined tant qu'aucun réglage n'a été fait en son nom.
export const readLook = (churchId = "") => {
  const fx = get(scoped(FX_KEY, churchId));
  const b = get(scoped(BEAUTY_KEY, churchId));
  if (churchId && fx === null && b === null) return undefined;
  return { fx: validFx(fx) ? fx : "normal", beauty: clampBeauty(b ?? 0) };
};

export const hasChurchLook = (churchId) => !!churchId && readLook(churchId) !== undefined;

// Le look d'une église sans réglage = le look personnel.
export const resolveLook = (churchId = "") => readLook(churchId) || readLook("");

export const writeLook = (churchId, { fx, beauty }) => {
  set(scoped(FX_KEY, churchId), validFx(fx) ? fx : "normal");
  set(scoped(BEAUTY_KEY, churchId), String(clampBeauty(beauty)));
};
